import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ChargebeePartnerDiscountCode } from '../../models/partner-discount-code';
import { PartnersService } from '../../services/partners.service';

@Component({
  standalone: false,
  templateUrl: './check-partner-code.component.html',
  styleUrls: ['./check-partner-code.component.scss'],
})
export class CheckPartnerCodeComponent implements OnInit {
  couponCode: string | null = null;
  coupon: ChargebeePartnerDiscountCode | null = null;

  constructor(
    private partnersService: PartnersService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      // We don't have a code
      if (!params.has('code')) {
        this.invalidCodeRedirect();
      }

      this.couponCode = params.get('code');

      this.fetchCodeDetails(this.couponCode);
    });
  }

  fetchCodeDetails(code: string) {
    this.partnersService.fetchPartnerDiscountCode(code).subscribe((res) => {
      if ('id' in res) {
        this.coupon = res;
      }

      this.validCodeRedirect();
    });
  }

  validCodeRedirect() {
    this.router.navigate(['/user/register/welcome'], { queryParams: { code: this.couponCode } });
  }

  invalidCodeRedirect() {
    this.router.navigate(['/user/register/welcome']);
  }
}
